import React from 'react';
import { Snackbar, Box, Typography, IconButton, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { palette } from '../../styles/theme';

const iconMap = {
    success: <CheckCircleIcon sx={{ color: palette.white, height: '1.846rem', width: '1.846rem' }} />,
    error: <ErrorIcon sx={{ color: palette.white, height: '1.846rem', width: '1.846rem' }} />,
    warning: <WarningIcon sx={{ color: palette.white, height: '1.846rem', width: '1.846rem' }} />,
    info: <InfoIcon sx={{ color: palette.white, height: '1.846rem', width: '1.846rem' }} />,
};

const DEFAULT_AUTO_HIDE_DURATION = 6000;

export default function CustomAlert ({ openAlert, setOpenAlert, alert, setAlert, autoHideDuration = DEFAULT_AUTO_HIDE_DURATION }) {
    const { t } = useTranslation();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlert({
            severity: '',
            title: '',
            description: '',
            className: ''
        });
    };

    return (
        <Snackbar
            open={openAlert || alert.isOpen}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={alert.severity === 'success' ? autoHideDuration : null}
            onClose={handleClose}
        >
            <Box
                className={alert.className}
                sx={{
                    backgroundColor: alert.backgroundColor || undefined,
                    color: palette.white,
                    px: '1.23rem',
                    py: '0.461rem',
                    borderRadius: '0.461rem',
                    gap: '0.923rem',
                    width: 'auto',
                    minWidth: '43.23rem',
                    height: 'auto',
                    minHeight: '5.846rem',
                    position: 'relative'
                }}
            >
                <Stack direction={'row'} gap={1} sx={{ flex: 1 }}>
                    <Box paddingY={0.5}>{alert.icon ? alert.icon : iconMap[alert.severity]}</Box>
                    <Stack sx={{ height: '100%', paddingY: '8px', flex: 1, alignItems: alert.centered ? 'center' : 'flex-start', textAlign: alert.centered ? 'center' : 'left' }} gap={1}>
                        {alert.title &&
                        <Typography variant="h4" color={palette.white} fontWeight={400} >
                            {t(alert.title)}
                        </Typography>
                        }
                        {alert.description &&
                        <Typography variant="h4" color={palette.white} fontWeight={400} fontSize={'14px'} sx={{ whiteSpace: 'pre-line' }}>
                            {t(alert.description)}
                            {alert.data ?? null}
                        </Typography>
                        }
                    </Stack>
                </Stack>

                {alert.severity !== 'success' && (
                    <IconButton disableRipple onClick={handleClose} sx={{ position: 'absolute', top: '0.615rem', right: '0.615rem', color: palette.white }}>
                        <CloseIcon sx={{ height: '1.846rem', width: '1.846rem' }} />
                    </IconButton>
                )}
            </Box>
        </Snackbar>
    );
}
